import classNames from 'classnames';
import { Container } from 'components/gruenland/atoms/container/Container';
import { TYPOGRAPHY_PAGE_TITLE } from 'lib/typography';
import { TasticProps } from '../../types';

interface Props {
  title: string;
}

const YggdrasilPageTitleTastic = ({ data }: TasticProps<Props>) => {
  return (
    <Container>
      <div className={classNames('mt-10 lg:mt-[80px]', TYPOGRAPHY_PAGE_TITLE)}>{data.title}</div>
    </Container>
  );
};

export default YggdrasilPageTitleTastic;
